import { PREVIEW_BLOCK_ITEM_TYPE } from '../types/types';

import { QUERY_FILTER_TYPE } from '@/entities/query/types';

export function getPreviewBlockItemTypeByFilterType(
  type: QUERY_FILTER_TYPE,
): PREVIEW_BLOCK_ITEM_TYPE {
  switch (type) {
    case QUERY_FILTER_TYPE.USERNAME:
      return PREVIEW_BLOCK_ITEM_TYPE.USERNAME;
    case QUERY_FILTER_TYPE.WORD:
      return PREVIEW_BLOCK_ITEM_TYPE.KEYWORD;
    default:
      return PREVIEW_BLOCK_ITEM_TYPE.KEYWORD;
  }
}
